// Translation strings for English and Arabic

export const translations = {
  en: {
    // Sidebar
    newChat: 'New Chat',
    newCodeWorkspace: 'New Code Workspace',
    noChatsYet: 'No chats yet',
    chatHistory: 'Chat History',

    // Chat Area
    typeMessage: 'Type your message...',
    send: 'Send',
    attachFile: 'Attach file',

    // CodeLab / Workspace
    aiAssistant: 'AI Assistant',
    explainCode: 'Explain Code',
    fixErrors: 'Fix Errors',
    optimize: 'Optimize',
    addComments: 'Add Comments',
    askAssistantPlaceholder: 'Ask the AI assistant...',
    run: 'Run',
    running: 'Running...',
    saving: 'Saving...',
    showChat: 'Show Chat',
    consoleOutput: 'Console Output',
    noOutputYet: 'No output yet. Click "Run" to execute your code.',
    errorLoadCode: 'Error: Failed to load code file',
    errorSaveCode: 'Error: Failed to save code',

    // Welcome Screen
    welcomeTitle: 'Welcome to Optimize AI Chatbot',
    welcomeSubtitle: 'Create a new chat to get started',
    startNewChat: 'Start New Chat',
    chatGreeting: 'Hello! How can I help you today?',

    // Session Actions
    rename: 'Rename',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    emailCannotBeChanged: 'Email cannot be changed',

    // File Upload
    uploadFile: 'Upload File',
    maxFileSize: 'Max file size: 10MB',
    allowedTypes: 'Allowed types: PDF, TXT, DOCX, images, CSV, JSON, MD',

    // Messages
    you: 'You',
    assistant: 'Assistant',

    // Errors
    errorSending: 'Error sending message',
    errorLoading: 'Error loading',

    // Language
    language: 'Language',
    english: 'English',
    arabic: 'العربية',

    // Authentication
    login: 'Sign In',
    logout: 'Sign Out',
    email: 'Email',
    password: 'Password',
    forgotPassword: 'Forgot your password?',
    dontHaveAccount: "Don't have an account?",
    requestAccess: 'Request Access',

    // Profile
    profile: 'Profile',
    firstName: 'First Name',
    lastName: 'Last Name',
    role: 'Role',
    status: 'Status',
    emailVerified: 'Email Verified',
    organizationId: 'Organization ID',
    userId: 'User ID',
    changePassword: 'Change Password',

    // Password Management
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordRequirements: 'Password Requirements',
    passwordMinLength: 'At least 8 characters long',
    passwordMixCase: 'Mix of uppercase and lowercase letters (recommended)',
    passwordSpecialChars: 'Include numbers and special characters (recommended)',
    passwordsDontMatch: "Passwords don't match",
    passwordChanged: 'Password changed successfully!',

    // Organizations
    organizations: 'Organizations',
    organization: 'Organization',
    newOrganization: 'New Organization',
    createOrganization: 'Create Organization',
    editOrganization: 'Edit Organization',
    organizationName: 'Organization Name',
    uniqueIdentifier: 'Unique Identifier',
    type: 'Type',
    address: 'Address',
    maxUsers: 'Max Users',
    coverageEnabled: 'Coverage Enabled',
    noOrganizationsYet: 'No organizations yet',
    getStartedOrganization: 'Get started by creating your first organization',

    // Users
    users: 'Users',
    user: 'User',
    inviteUser: 'Invite User',
    editUser: 'Edit User',
    noUsersFound: 'No users found in this organization',
    noUsersFoundInOrganization: 'No users found in this organization',
    manageUsersInOrganization: 'Manage users in this organization',
    toggleStatus: 'Toggle Status',
    superAdmin: 'Super Admin',
    admin: 'Admin',
    manager: 'Manager',
    unknown: 'Unknown',
    sendInvitationEmail: 'Send invitation email to new user',
    invitationSentSuccessfully: 'Invitation sent successfully!',
    invitationEmailDescription: 'An invitation email will be sent to this address',
    roleWillBeAssigned: 'This role will be assigned when user accepts invitation',
    whatHappensNext: 'What happens next?',
    invitationStep1: 'User receives invitation email with registration link',
    invitationStep2: 'User clicks link and completes registration',
    invitationStep3: 'User can login with their new account',
    sendInvitation: 'Send Invitation',
    sending: 'Sending...',

    // Common
    backTo: 'Back to',
    saveChanges: 'Save Changes',
    loading: 'Loading...',
    edit: 'Edit',
    active: 'Active',
    inactive: 'Inactive',
    invited: 'Invited',
    verified: 'Verified',
    notVerified: 'Not Verified',
    actions: 'Actions',
    pendingPayment: 'Pending Payment',
    suspended: 'Suspended',
    trialExpired: 'Trial Expired',
    pendingpayment: 'Pending Payment',
    trialexpired: 'Trial Expired'
  },
  ar: {
    // Sidebar
    newChat: 'محادثة جديدة',
    newCodeWorkspace: 'مساحة عمل برمجية جديدة',
    noChatsYet: 'لا توجد محادثات بعد',
    chatHistory: 'سجل المحادثات',

    // Chat Area
    typeMessage: 'اكتب رسالتك...',
    send: 'إرسال',
    attachFile: 'إرفاق ملف',

    // CodeLab / Workspace
    aiAssistant: 'المساعد الذكي',
    explainCode: 'اشرح الكود',
    fixErrors: 'إصلاح الأخطاء',
    optimize: 'تحسين الكود',
    addComments: 'إضافة تعليقات',
    askAssistantPlaceholder: 'اسأل المساعد عن الكود...',
    run: 'تشغيل',
    running: 'جاري التشغيل...',
    saving: 'جاري الحفظ...',
    showChat: 'إظهار الدردشة',
    consoleOutput: 'مخرجات الكونسول',
    noOutputYet: 'لا توجد مخرجات بعد. اضغط "تشغيل" لتنفيذ الكود.',
    errorLoadCode: 'خطأ: فشل في تحميل ملف الكود',
    errorSaveCode: 'خطأ: فشل في حفظ الكود',

    // Welcome Screen
    welcomeTitle: 'مرحباً بك في Optimize AI Chatbot',
    welcomeSubtitle: 'أنشئ محادثة جديدة للبدء',
    startNewChat: 'بدء محادثة جديدة',
    chatGreeting: 'مرحباً! كيف يمكنني مساعدتك اليوم؟',

    // Session Actions
    rename: 'إعادة تسمية',
    delete: 'حذف',
    cancel: 'إلغاء',
    save: 'حفظ',
    emailCannotBeChanged: 'لا يمكن تغيير البريد الإلكتروني',

    // File Upload
    uploadFile: 'رفع ملف',
    maxFileSize: 'الحد الأقصى لحجم الملف: 10 ميجابايت',
    allowedTypes: 'الأنواع المسموحة: PDF, TXT, DOCX, صور, CSV, JSON, MD',

    // Messages
    you: 'أنت',
    assistant: 'المساعد',

    // Errors
    errorSending: 'خطأ في إرسال الرسالة',
    errorLoading: 'خطأ في التحميل',

    // Language
    language: 'اللغة',
    english: 'English',
    arabic: 'العربية',

    // Authentication
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    forgotPassword: 'هل نسيت كلمة المرور؟',
    dontHaveAccount: 'ليس لديك حساب؟',
    requestAccess: 'طلب الوصول',

    // Profile
    profile: 'الملف الشخصي',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    role: 'الدور',
    status: 'الحالة',
    emailVerified: 'البريد الإلكتروني مُتحقق منه',
    organizationId: 'معرف المؤسسة',
    userId: 'معرف المستخدم',
    changePassword: 'تغيير كلمة المرور',

    // Password Management
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    passwordRequirements: 'متطلبات كلمة المرور',
    passwordMinLength: 'على الأقل 8 أحرف',
    passwordMixCase: 'مزيج من الأحرف الكبيرة والصغيرة (موصى به)',
    passwordSpecialChars: 'تضمين أرقام وأحرف خاصة (موصى به)',
    passwordsDontMatch: 'كلمات المرور غير متطابقة',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح!',

    // Organizations
    organizations: 'المؤسسات',
    organization: 'المؤسسة',
    newOrganization: 'مؤسسة جديدة',
    createOrganization: 'إنشاء مؤسسة',
    editOrganization: 'تعديل المؤسسة',
    organizationName: 'اسم المؤسسة',
    uniqueIdentifier: 'المعرف الفريد',
    type: 'النوع',
    address: 'العنوان',
    maxUsers: 'الحد الأقصى للمستخدمين',
    coverageEnabled: 'التغطية مفعلة',
    noOrganizationsYet: 'لا توجد مؤسسات بعد',
    getStartedOrganization: 'ابدأ بإنشاء مؤسستك الأولى',

    // Users
    users: 'المستخدمون',
    user: 'المستخدم',
    inviteUser: 'دعوة مستخدم',
    editUser: 'تعديل المستخدم',
    noUsersFound: 'لم يتم العثور على مستخدمين في هذه المؤسسة',
    noUsersFoundInOrganization: 'لم يتم العثور على مستخدمين في هذه المؤسسة',
    manageUsersInOrganization: 'إدارة المستخدمين في هذه المؤسسة',
    toggleStatus: 'تبديل الحالة',
    superAdmin: 'مدير عام',
    admin: 'مدير',
    manager: 'مشرف',
    unknown: 'غير معروف',
    sendInvitationEmail: 'إرسال بريد دعوة للمستخدم الجديد',
    invitationSentSuccessfully: 'تم إرسال الدعوة بنجاح!',
    invitationEmailDescription: 'سيتم إرسال بريد دعوة إلى هذا العنوان',
    roleWillBeAssigned: 'سيتم تعيين هذا الدور عند قبول المستخدم للدعوة',
    whatHappensNext: 'ماذا سيحدث بعد ذلك؟',
    invitationStep1: 'يستلم المستخدم بريد الدعوة مع رابط التسجيل',
    invitationStep2: 'ينقر المستخدم على الرابط ويكمل التسجيل',
    invitationStep3: 'يمكن للمستخدم تسجيل الدخول بحسابه الجديد',
    sendInvitation: 'إرسال الدعوة',
    sending: 'جاري الإرسال...',

    // Common
    backTo: 'العودة إلى',
    saveChanges: 'حفظ التغييرات',
    loading: 'جاري التحميل...',
    edit: 'تعديل',
    active: 'نشط',
    inactive: 'غير نشط',
    invited: 'مدعو',
    verified: 'مُتحقق منه',
    notVerified: 'غير مُتحقق منه',
    actions: 'الإجراءات',
    pendingPayment: 'في انتظار الدفع',
    suspended: 'معلق',
    trialExpired: 'انتهت الفترة التجريبية',
    pendingpayment: 'في انتظار الدفع',
    trialexpired: 'انتهت الفترة التجريبية'
  }
};

export type Language = 'en' | 'ar';
export type TranslationKey = keyof typeof translations.en;
